import type { LogGroup } from "@shared/types/scraping";
import { CheckCircle2, XCircle } from "lucide-react";
import * as liveLogsStyles from "./LiveLogs.styles";
import { LogEntryRow } from "./LogEntryRow";
import * as paymentStyles from "./Payment.styles";

const LogGroupSection = ({ group }: { group: LogGroup }) => (
  <div>
    <div className={liveLogsStyles.logGroupHeader}>
      <span className={liveLogsStyles.logGroupHeaderTitle}>{group.header}</span>
      {group.result !== undefined &&
        (group.result ? <CheckCircle2 className={paymentStyles.successIcon} /> : <XCircle className={paymentStyles.errorIcon} />)}
    </div>
    {group.logs.map((log, li) => (
      <LogEntryRow key={li} entry={log} />
    ))}
  </div>
);

export { LogGroupSection };
